export { default } from './RichDescription';